export default __webpack_public_path__ + "static/media/logo-pattern-analytics.e18edbaa.svg";